var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSafe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00BC7D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167,
  d: "M12.669 8.749c0 2.916-2.042 4.374-4.468 5.22a.58.58 0 0 1-.391-.006c-2.433-.84-4.474-2.298-4.474-5.214V4.665a.583.583 0 0 1 .583-.583c1.167 0 2.625-.7 3.64-1.586a.68.68 0 0 1 .887 0c1.02.892 2.473 1.586 3.64 1.586a.583.583 0 0 1 .583.583z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00BC7D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167,
  d: "m6.25 8.167 1.167 1.166L9.75 7"
})));
export default SvgSafe;